import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const organisationRecordSalesWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.record.sales",
  name: "Sales orders · 30 days",
  description: "Sales orders · 30 days for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Sales orders · 30 days",
    subtext: "",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
